import { getPreferredViewportType, isDisplayableViewportTypes, } from './viewportTypes.js';
export class BaseDisplaySet {
    constructor(options) {
        this.displaySetId = options.displaySetId;
        this.viewportTypes = options.viewportTypes?.length
            ? [...options.viewportTypes]
            : ['stack'];
        this.preferredViewportType = getPreferredViewportType(this.viewportTypes);
        this.isDisplayable = isDisplayableViewportTypes(this.viewportTypes);
        this.instances = [...(options.instances ?? [])];
        this.imageIds = [...(options.imageIds ?? [])];
        this.underlyingImageIds = [...(options.underlyingImageIds ?? [])];
    }
}
